export default __webpack_public_path__ + "1d75fa97f338e094a68c96e50c97961e.svg";